import questionTypes from '../questionTypes';
import formatValidationTypeList from '../formatValidationTypeList';
import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentPhone,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    label: 'Phone number',
    formatValidationType: formatValidationTypeList.phone,
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isUniqueField: () => true,
    isRequiredField: () => false,
    isTextRequired: () => false,
  },
};
